// src/Informes/Components/Helpers.js
import React from "react";

export const renderCellContent = (value, defaultValue = "SIN ASOCIACIÓN") => (
  <>{value?.id ? value.asoc_name || value.zona : defaultValue}</>
);

export const renderCell = (value) => <>{value ? value : ""}</>;

export const renderNumericValue = (value) => <>{value !== 0 ? value : 0}</>;

export const getRandomColor = () => {
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);
  return `#${randomColor}`;
};
